module.exports = __webpack_public_path__ + "img/Lighting_Bull_Color_22_NOBG_.0010.c531847e.webp";